/* Culture Shock - behaviour for the card quick-buy button.
 *
 * WHY THIS EXISTS (Aug 21 2026)
 * The quick "Buy now" on product cards is rendered with Motion's `form.product`
 * snippet, whose <product-form> custom element DOES add to the cart over AJAX -
 * and then fires a CANCELLABLE `product-form:cart:navigate` event. If nobody
 * cancels it, it does `window.location.href = /cart`.
 *
 * On the product page nothing breaks because the standard PDP uses a DIFFERENT
 * snippet (`product-form.liquid`, the legacy one) that theme.js wires to the
 * drawer directly. Motion only cancels the navigation on its high-variant
 * template - see sections/main-product-high-variant.liquid, which is where
 * these two listeners are copied from.
 *
 * So a card click was adding the item and then hard-navigating to /cart instead
 * of opening the drawer. Verified: the item DID reach the cart, the page just
 * left. Both listeners are scoped to `.cs-card-buy` so nothing else on the site
 * changes behaviour.
 */
(function () {
  function isCardBuy(event) {
    return event.target && event.target.closest && event.target.closest('.cs-card-buy');
  }

  document.addEventListener('product-form:cart:navigate', function (event) {
    if (!isCardBuy(event)) return;
    // cartType 'page' means the merchant WANTS a full cart page - respect it
    if (window.theme && theme.settings && theme.settings.cartType === 'page') return;
    event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', function (event) {
    if (!isCardBuy(event)) return;
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });
})();
